import React, { useState, useEffect, useCallback } from "react";

//BootstrapTable
import BootstrapTable from "react-bootstrap-table-next";

//reactstrap
import { Button } from "reactstrap";

//paginator
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

//untils
import { LoaderText, apiCaller } from "@utils";

//DataEmty
import { DataEmty } from "@components/common";

//Icon
import { Iconsax } from "@components-common";

//LevelBox
import { LevelBox } from "@components/Makansafe";

//elements
import { BtnIconDeleteV2, BtnIconEditV2 } from "@ui-partents/Button";

//react-router-dom
import { useHistory } from 'react-router-dom';

//components
import { FilterContainer, TableHeader, DeleteModal, ValidateFoodItem } from "../Home";
import { TableCheckbox } from "../";

//styled-components
import {
    SearchFieldAreaStyles,
    TableContainer,
    ContentTableWrapper,
    FilterHeaderContainer,
    SearchFieldArea,
    SearchInner,
    SearchField,
    SearchFieldInner,
    SearchIconContainer,
    SearchInputContainer,
    FakePlaceholder,
    ClearButton,
    SelectionRowWrapper,
    PaginationWrapper,
    FoodItemCellWrapper
} from './TableFoods.styled';

//Images Default
import NotAvailable from "@images/makansafe/not-available.png";

//components
import { ModalModification } from "../Home";

//Language
import { useLanguage } from '@context/LanguageContext';

//partents
import { SortCaret } from "@ui-partents/Table";

// Import the pagination configuration
import { paginationOptions } from "@utils";

function TableFoods(props) {
    const maxLength = 120; // Độ dài tối đa của chuỗi
    let history = useHistory();
    const { language } = useLanguage();

    //state
    const [modal, setModal] = useState({
        deleteFood: false,
        modification: false
    });
    const [isLoading, setLoading] = useState({
        deleteFood: false,
        getAllData: false
    });
    const [foodsDataState, setFoodsDataState] = useState([]);
    const [rowChecked, setRowChecked] = useState([]);
    const [rowOneChecked, setRowOneChecked] = useState(null);
    const [itemActive, setItemActive] = useState(null);
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    // useCallback for fetchDataFoods
    const fetchDataFoods = useCallback((type) => {
        //reset
        setFoodsDataState([]);

        type && setLoading(prevState => ({ ...prevState, [type]: true }));
        const params = {
            action_type: "get_full_data",
            lang: language.value
        };
        //Truyền true hàm apiCaller để sử dụng api makansafe
        apiCaller(`/api/iddsi/functional/`, "POST", params, true).then(res => {
            const resData = res?.data;
            if (res?.status === 200) {
                setFoodsDataState(resData.map(food => ({
                    ...food,
                    modification: "",
                    modifyToLevel: null
                })));
                type && setLoading(prevState => ({ ...prevState, [type]: false }));
            } else {
                console.log("error");
                type && setLoading(prevState => ({ ...prevState, [type]: false }));
            }
        });
    }, [language.value]);

    //load Foods
    useEffect(() => {
        fetchDataFoods("getAllData");
    }, [fetchDataFoods]);

    // Effect to handle focus/blur on search input
    useEffect(() => {
        const handleFocus = () => setIsSearchFocused(true);
        const handleBlur = () => setIsSearchFocused(false);
        
        const searchInput = document.querySelector('.serach_field-area .search_field input');
        if (searchInput) {
            searchInput.addEventListener('focus', handleFocus);
            searchInput.addEventListener('blur', handleBlur);
            
            return () => {
                searchInput.removeEventListener('focus', handleFocus);
                searchInput.removeEventListener('blur', handleBlur);
            };
        }
    }, [foodsDataState]); // Re-run when data changes to re-attach listeners

    const columns = [
        {
            dataField: "food_id",
            text: "ID",
            hidden: true,
            headerClasses: "align-middle font-weight-500 text-nowrap text-center",
            classes: "align-middle"
        },
        {
            dataField: "image_url",
            text: "Image",
            headerClasses: "align-middle font-weight-500 text-nowrap",
            formatter: (cell, row) => <div className="food-thumbnail"><img src={cell || NotAvailable} alt={row.FoodItem} /></div>,
            classes: "align-middle"
        },
        {
            dataField: "food_name",
            text: "Food Item",
            headerClasses: "align-middle font-weight-500 text-nowrap",
            classes: "align-middle",
            sort: true,
            sortCaret: (order, column) => <SortCaret order={order} />,
            formatter: (cell, row) => (
                <FoodItemCellWrapper>
                    {cell}
                </FoodItemCellWrapper>
            )
        },
        {
            dataField: "default_level",
            text: "Default Level",
            headerClasses: "align-middle font-weight-500 text-nowrap text-center",
            formatter: (cell, row) => (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                    <LevelBox level={cell} />
                </div>
            ),
            classes: "align-middle"
        },
        {
            dataField: "default_level_note",
            text: "Default Level Description",
            headerClasses: "align-middle font-weight-500 text-nowrap",
            classes: "align-middle",
            headerStyle: (colum, colIndex) => {
                return { minWidth: "250px" };
            },
            formatter: (cell, row) => cell?.length > maxLength ? cell.substring(0, maxLength) + "..." : cell
        },
        {
            dataField: "modification",
            text: "Modification",
            headerClasses: "align-middle font-weight-500 text-nowrap",
            classes: "align-middle",
            formatter: (cell, row) => {
                return (
                    <Button
                        className="text-nowrap"
                        color="primary"
                        onClick={() => toggle('modification', row)}
                    >
                        View Modification
                    </Button>
                )
            }
        },
        {
            dataField: "validated",
            text: "Reviewed?",
            headerClasses: "align-middle font-weight-500 text-nowrap text-center",
            formatter: (cell, row) => (
                <ValidateFoodItem {...props} row={row} cell={cell} />
            ),
            classes: "align-middle"
        },
        {
            dataField: "Actions",
            text: "",
            style: { width: "100px", whiteSpace: "nowrap" },
            headerClasses: "align-middle font-weight-400 text-center",
            classes: "align-middle",
            formatter: (cell, row) => {
                const handleEditButtonClick = (foodId) => {
                    localStorage.removeItem('generatedFoodData');
                    history.push(`/makansafe/edit-food/${foodId}`);
                };
                return (
                    <div className="d-flex align-items-center justify-content-center">
                        <BtnIconEditV2 handleEditButtonClick={() => handleEditButtonClick(row?.food_id)} />
                        <BtnIconDeleteV2 handleDelete={() => toggle("deleteFood", row)} />
                    </div>
                );
            },
        },
    ];

    // Custom Pagination Component
    const CustomPagination = ({ paginationProps }) => (
        <PaginationListStandalone
            {...paginationProps}
            noBorder={true}
        />
    );

    //toggle
    const toggle = (type, item) => {
        setModal(prevState => ({ ...prevState, [type]: !prevState[type] }));
        if (item?.food_id) {
            setRowOneChecked([item?.food_id]);
            setItemActive(item);
        } else {
            setRowOneChecked(null);
        }
    };

    const SelectionRowRenderer = ({ mode, checked, onChange, ...rest }) => {
        const { rowIndex, ...otherProps } = rest;
        return (
            <SelectionRowWrapper>
                <TableCheckbox
                    checked={checked}
                    onChange={onChange}
                    id={rowIndex !== undefined ? `selectRow_${rowIndex}` : 'selectAllRows'}
                    readOnly={false}
                    {...otherProps}
                />
            </SelectionRowWrapper>
        );
    };

    const handleDeleteMultiplesFood = () => {
        const params = {
            "action_type": "delete_multiples",
            "ids": rowChecked?.length > 0 ? rowChecked : rowOneChecked
        }

        setLoading(prevState => ({ ...prevState, deleteFood: true }));
        //Truyền true hàm apiCaller để sử dụng api makansafe
        apiCaller(`/api/iddsi/functional/`, "POST", params, true).then(res => {
            if (res?.status === 200) {
                setLoading(prevState => ({ ...prevState, deleteFood: false }));
                toggle('deleteFood');
                fetchDataFoods(null); // Reload data after successful delete
                setRowChecked([]);
                setRowOneChecked([]);
            } else {
                console.log("error");
                setLoading(prevState => ({ ...prevState, deleteFood: false }));
                toggle('deleteFood');
            }
        });
    }

    const selectRow = {
        mode: 'checkbox',
        clickToSelect: false,
        selectionHeaderRenderer: SelectionRowRenderer,
        selectionRenderer: SelectionRowRenderer,
        style: { backgroundColor: '#F2F4F7' },
        onSelect: (row, isSelect) => {
            let newArray = [...rowChecked, row?.food_id];
            if (rowChecked.includes(row?.food_id)) {
                newArray = newArray.filter((item) => item !== row?.food_id);
            }
            setRowChecked(newArray);
        },

        onSelectAll: (isSelect, rows, e) => {
            const newArr = [];
            if (isSelect) {
                rows.map((value) => newArr.push(value?.food_id));
                setRowChecked(newArr);
            } else {
                setRowChecked([]);
            }
        },
        headerColumnStyle: {
            verticalAlign: 'middle'
        },
        selectColumnStyle: {
            verticalAlign: 'middle'
        }
    };

    const { SearchBar } = Search;
    const contentTable = ({ paginationProps, paginationTableProps }) => (
            <ContentTableWrapper>
                <SearchFieldAreaStyles />
                <ToolkitProvider
                    keyField="food_id"
                    data={foodsDataState || []}
                    columns={columns}
                    search
                >
                    {(toolkitprops) => (
                        <React.Fragment>
                            <FilterHeaderContainer className="filter-header-container">
                                <FilterContainer
                                    toolkitprops={toolkitprops}
                                    rowChecked={rowChecked}
                                    handleDelete={() => toggle("deleteFood")}
                                    isLoading={isLoading}
                                    rowOneChecked={rowOneChecked}
                                />
                                <SearchFieldArea className="serach_field-area">
                                    <SearchInner className="search_inner">
                                        <SearchField className="search_field">
                                            <SearchFieldInner>
                                                {!toolkitprops?.searchProps?.searchText && !isSearchFocused && (
                                                    <SearchIconContainer>
                                                        <Iconsax iconName="search" fill="#667085" size={20} />
                                                    </SearchIconContainer>
                                                )}
                                                <SearchInputContainer>
                                                    <SearchBar 
                                                        {...toolkitprops.searchProps} 
                                                        onSearch={(e) => {
                                                            paginationProps.page = 1
                                                            toolkitprops.searchProps.onSearch(e)
                                                        }}
                                                        placeholder=""
                                                        style={{ 
                                                            flex: '1 1 0%', 
                                                            minWidth: 0, 
                                                            width: '100%', 
                                                            paddingLeft: (!toolkitprops?.searchProps?.searchText && !isSearchFocused) ? '32px' : '0px' 
                                                        }}
                                                    />
                                                    {!toolkitprops?.searchProps?.searchText && !isSearchFocused && (
                                                        <FakePlaceholder className="search_field__fake-placeholder">Search</FakePlaceholder>
                                                    )}
                                                </SearchInputContainer>
                                                {toolkitprops?.searchProps?.searchText && (
                                                    <ClearButton className="search_field__clear" onClick={toolkitprops.searchProps.onClear}>
                                                        <Iconsax iconName="close-box" fill="#98A2B3" size={20} />
                                                    </ClearButton>
                                                )}
                                            </SearchFieldInner>
                                        </SearchField>
                                    </SearchInner>
                                </SearchFieldArea>
                            </FilterHeaderContainer>
                        <BootstrapTable
                            wrapperClasses="table-responsive"
                            bordered={false}
                            data={foodsDataState}
                            columns={columns}
                            noDataIndication={() => (
                                <DataEmty content="No Data" />
                            )}
                            selectRow={selectRow}
                            {...toolkitprops.baseProps}
                            {...paginationTableProps}
                        />
                    </React.Fragment>
                )}
            </ToolkitProvider>
                            <PaginationWrapper>
                                <PaginationListStandalone {...paginationProps} />
                            </PaginationWrapper>
            </ContentTableWrapper>
    );

    // Define your configuration parameters
    const paginationConfig = {
        paginationComponent: CustomPagination,
        totalSize: foodsDataState?.length || 0 // Set total size based on data length
    };

    // Define the dynamic options
    const finalPaginationOptions = paginationOptions({
        paginationComponent: paginationConfig.paginationComponent,
        totalSize: paginationConfig.totalSize
    });
    return (
        <React.Fragment>
            <TableHeader
                {...props}
                foodsDataState={foodsDataState}
            />
            <TableContainer className="table-food table-custom-makansafe">
                {isLoading?.getAllData && <LoaderText />}
                <PaginationProvider pagination={paginationFactory(finalPaginationOptions)}>
                    {contentTable}
                </PaginationProvider>
            </TableContainer>
            <DeleteModal
                isOpen={modal?.deleteFood}
                toggle={() => toggle('deleteFood')}
                isLoading={isLoading?.deleteFood}
                handleRemove={handleDeleteMultiplesFood}
            />
            <ModalModification
                isOpen={modal?.modification}
                toggleModal={() => toggle('modification')}
                itemActive={itemActive}
            />
        </React.Fragment>
    );
}

export default TableFoods;